import { render, staticRenderFns } from "./branchoffice-select.vue?vue&type=template&id=70639516"
import script from "./branchoffice-select.vue?vue&type=script&lang=js"
export * from "./branchoffice-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports